<template>
  <div>
    <div style="position: absolute; right: 10px; top: 40px">
      <div class="d-flex flex-column align-end keypad" style="">
        <h2 style="color: black">Animation & Shortcut</h2>

        <div class="mt-3 d-flex align-center" v-for="{ label, onClick, key } in cameraButtons" :key="key">
          <v-btn @click="onClick" color="#444444" style="color: white" small>{{ label }}</v-btn>
          <div class="ml-2"></div>
          <v-chip small>Ctrl + {{ key }}</v-chip>
        </div>

        <div class="mt-3"></div>

        <div class="mt-3 d-flex align-center" v-for="{ label, onClick, key } in animationButtons" :key="key">
          <v-btn @click="onClick" color="#444444" style="color: white" small>{{ label }}</v-btn>
          <div class="ml-2"></div>
          <v-chip small>Ctrl + {{ key }}</v-chip>
        </div>
      </div>
    </div>
    <div>
      <input type="file" ref="fileInput" @change="onFilePicked" multiple />

      <div class="three-wrapper">
        <div id="three"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AppRenderer from "../../../domain/AppRenderer";
import AppModelFacade from "@/domain/facades/AppModelFacade";
import APP_CAMERA_POSITIONS from "@/constants/APP_CAMERA_POSITIONS";

export default {
  data() {
    return {
      cameraButtons: [],
      animationButtons: [],
      cameraPosition: { ...APP_CAMERA_POSITIONS.ZOOM_OUT_1 },
    };
  },
  async mounted() {
    try {
      this.isOnLoading = true;
    } catch (error) {
      this.isOnLoading = false;
      throw error;
    }
  },
  methods: {
    async onFilePicked(event) {
      try {
        const appModel = await AppModelFacade.loadModelFrom(event.target.files || []);
        this.loadModel(appModel);
      } catch (error) {
        console.error(error);
        alert(error.message);
      }
    },
    async loadModel(appModel) {
      // create button depend on animation name
      const parent = this.$el.querySelector("#three");
      const appRenderer = AppRenderer.create(appModel, { width: 400, height: 400, scale: 2 }, this.cameraPosition);
      parent.appendChild(appRenderer.canvasEl);
      this.cameraButtons.push({
        name: "Restore",
        label: "카메라 위치 복구",
        onClick: () => {
          appRenderer.restoreCamera();
        },
        key: "1",
      });

      // Class 안으로 넣어야 겠다
      Object.keys(appRenderer.mixerMap).forEach((key, i) => {
        if (key.startsWith("_")) return;
        this.animationButtons.push({
          name: key,
          label: (() => {
            if (key === "Root|740428|BaseLayer") return "하암 !@!";
            else if (key === "hi") return "안녕하세요 :)";
            else return key;
          })(),
          onClick: () => {
            appRenderer.play(key);
          },
          key: `${i + 2}`,
        });
      });
      window.onresize = appRenderer.createOnResize(parent);
      this.isOnLoading = false;
      // BELOW CODE IS FOR KEYDOWN EVENT
      const actionMaps = [...this.cameraButtons, ...this.animationButtons];
      const keys = actionMaps.map(({ key }) => key);
      document.removeEventListener("keydown", this.keyDownHandler); // 제대로 제거가 안되면 두번씩 호출된다
      this.keyDownHandler = (event) => {
        if (event.ctrlKey && keys.includes(event.key)) {
          actionMaps.find(({ key }) => key === event.key).onClick();
          event.preventDefault(); // Optional: prevent the default action
        }
      };
      document.addEventListener("keydown", this.keyDownHandler);
      // @duplicate with on air page
      window.virtupet_event = {};
      actionMaps.forEach(({ key, onClick }) => {
        window.virtupet_event[key] = onClick;
      });
    },
  },
};
</script>

<style scoped>
.three-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#three {
  width: fit-content;
  height: fit-content;
  background-color: red;
}
</style>
